export const openUrl = (url: string) => window.open(url, '_target');
